import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import * as yup from 'yup';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

export const FieldConfigForm = ({fieldConfig,control}) => {
   return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
          {fieldConfig.map((field) => (
                <Controller
                    key={field._id}
                    name={field.fieldName}
                    control={control}
                    defaultValue={field.fieldType === 'Boolean' ? false : ''}
                    rules={{ required: field.isRequired }}
                    render={({ field: controllerField, fieldState }) => {
                        // Render widget based on field type
                        if (field.domainvalues && field.domainvalues.length > 0) {
                            // Dropdown
                            return (
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>{field.fieldLabel}</InputLabel>
                                    <Select
                                        {...controllerField}
                                        label={field.fieldLabel}
                                        error={!!fieldState.error}
                                    >
                                        {field.domainvalues.map((value) => (
                                            <MenuItem key={value} value={value}>
                                                {value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            );
                        } else if (field.fieldType === 'Date') {
                            // Date Picker
                            return (
                                <DatePicker
                                    label={field.fieldLabel}
                                    {...controllerField}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? `${field.fieldName} is required` : ''}
                                            fullWidth
                                            margin="normal"
                                        />
                                    )}
                                />
                            );
                        } else if (field.fieldType === 'Boolean') {
                            // Checkbox
                            return (
                                <FormControlLabel
                                    control={<Checkbox {...controllerField} checked={!!controllerField.value} />}
                                    label={field.fieldLabel}
                                />
                            );
                        } else {
                            // Default TextField
                            return (
                                <TextField
                                    {...controllerField}
                                    label={field.fieldLabel}
                                    type={field.fieldType.toLowerCase()}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error ? `${field.fieldName} is required` : ''}
                                    fullWidth
                                    margin="normal"
                                />
                            );
                        }
                    }}
                />
            ))}
        
      </LocalizationProvider>
  );
};
export const FieldConfigYup = (fieldConfig)=>{
  const shape = {};

  fieldConfig.forEach((field) => {
      const { fieldName,fieldLabel, fieldType, isRequired, domainvalues } = field;

      let validator;

      // Define validators based on field type
      if (domainvalues && domainvalues.length > 0) 
        {
             validator = yup.string();
             validator = validator.oneOf(domainvalues, `${fieldLabel} must be one of ${domainvalues.join(', ')}`);
        }
        else
        {
            switch (fieldType) {
                case 'String':
                    validator = yup.string();
                    break;
                case 'Number':
                    validator = yup.number().typeError(`${fieldLabel} must be a number`);
                    break;
                case 'Boolean':
                    validator = yup.boolean();
                    break;
                case 'Date':
                    validator = yup.date().typeError(`${fieldLabel} must be a valid date`);
                    break;
                default:
                    validator = yup.mixed();
                    break;
            }
        }
      

      // Add dropdown constraints for fields with domainvalues
     

      // Add required constraint
      if (isRequired) {
          validator = validator.required(`${fieldName} is required`);
      }

      // Assign validator to field name
      shape[fieldName] = validator;
  });

  return shape
}
export const FieldConfigGrid = (fieldConfig) => {
  const gridColumns = fieldConfig
  .filter((field) => field.showOnGrid)
  .map((field) => {
      const columnDefinition = {
          field: field.fieldName,
          headerName: field.fieldLabel,
          width: 250,
          filterable: true,
      };

      // Handle rendering and filtering for dropdown fields
      if (field.domainvalues && field.domainvalues.length > 0) {
          columnDefinition.valueOptions = field.domainvalues; // Options for filtering
          columnDefinition.renderCell = (params) => params.value || '-'; // Display selected value
      }

      // Format rendering for other field types (e.g., Boolean, Date)
      if (field.fieldType === 'Boolean') {
          columnDefinition.renderCell = (params) => (params.value ? 'Yes' : 'No');
      } else if (field.fieldType === 'Date') {
          columnDefinition.renderCell = (params) =>
              params.value ? new Date(params.value).toLocaleDateString() : '-';
      }

      return columnDefinition;
  });
  return gridColumns
};